export default state => {
    return Object.assign({}, state, { queries: state.queries + 1 });
};